/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Position
 */
export interface Position {
    /**
     * 
     * @type {Date}
     * @memberof Position
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    lon: number;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    alt?: number;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    speed?: number;
}

export function PositionFromJSON(json: any): Position {
    return PositionFromJSONTyped(json, false);
}

export function PositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Position {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': (new Date(json['time'])),
        'lat': json['lat'],
        'lon': json['lon'],
        'alt': !exists(json, 'alt') ? undefined : json['alt'],
        'speed': !exists(json, 'speed') ? undefined : json['speed'],
    };
}

export function PositionToJSON(value?: Position | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': (value.time.toISOString()),
        'lat': value.lat,
        'lon': value.lon,
        'alt': value.alt,
        'speed': value.speed,
    };
}


